import * as actionTypes from '../actions';

let initialState = {
    refuellers: [],
    isLoading: true,
    convCharges: '',
    orderFail: '',
    getOrderError: '',
    count: 0,
    singleOrder: [],
    currentOrder: [],
    ongoingOrder: [],
    currentOrderCount: 0,
    pastOrder: [],
    pastOrderCount: 0,
    overdueOrder: [],
    placeOrder: [],
    allOrders: [],
    allPartnerOrders: [],
    accept: '',
    refuelerCount: '',
    sessionExpired: false,
    orderAlreadyPlaced: false,
    statusCode: 0,
    orderpaymentInfo: null,
    orderSuccess: null,
    orderNumber: null,
    isPayLoading: false,
    cancelOrder: [],
    energyScore: '',
    allOrdersNext: null,
    currentOrdersNext: null,
    pastOrdersNext: null,
    getLocation: '',
    getPaylableAmount: '',
    getFleetAccount: "",
    getPlaceorderData: "",
    allAssetList: [],
    lowAssetList: [],
    isLoadingLowFuel: true,
    isLoadingAllAssets: true,
    assetListFail: '',
    lowAssetFail: '',
    partnerList: [],
    partnerListFail: '',
    isLoadingPartnerList: true,
    orderSummaryList:'',
    orderSummaryFail:'',
    isLoadingorderSummary:true,
};

function getUnique(array, key) {
    if (!Array.isArray(array) || array.length === 0) {
        return [];
    }
    if (typeof key !== 'function') {
        const property = key;
        key = function (item) {
            return item[property];
        };
    }
    return Array.from(array.reduce(function (map, item) {
        const k = key(item);
        if (!map.has(k)) map.set(k, item);
        return map;
    }, new Map()).values());
}

const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REFUELERS: {
            return {
                ...state,
                refuellers: action.payload.refuelers,
                isLoading: false,
                refuelerCount: action.payload.refuelers.length,
                sessionExpired: false,
                orderAlreadyPlaced: false
            };
        }
        case actionTypes.SESSION_EXPIRED: {
            return {
                ...state,
                sessionExpired: true,
                isLoading: false
            };
        }
        case actionTypes.ORDER_LOADING: {
            return {
                ...state,
                isLoading: true,
                sessionExpired: false,

            };
        }
        case actionTypes.PAY_LOADING: {
            return {
                ...state,
                isPayLoading: true,
                openPayDialog: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_CONVENIENCE: {
            return {
                ...state,
                convCharges: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.ORDER_ALREADY_PRESENT: {
            return {
                ...state,
                orderAlreadyPlaced: true,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.PROCESS_ORDER_DIALOG: {
            return {
                ...state,
                orderAlreadyPlaced: false,
                isLoading: false,
            };
        }
        case actionTypes.PLACE_ORDER_FAIL: {
            return {
                ...state,
                orderFail: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_ALL_ORDER: {
            return {
                ...state,
                allOrders: getUnique(state.allOrders.concat(action.payload.results), 'id'),
                count: action.payload.count,
                isLoading: false,
                sessionExpired: false,
                allOrdersNext: action?.payload?.next

            };
        }
        case actionTypes.GET_ALL_PARTNER_ORDER: {
            const hasMore = action?.payload?.results?.length > 0 && action?.payload?.next;
            return {
                ...state,
                allPartnerOrders: getUnique(
                    state.allPartnerOrders.concat(action.payload.results),
                    "id"
                ),
                count: action.payload.count,
                isLoading: false,
                sessionExpired: false,
                allPartnerOrdersNext: hasMore ? action.payload.next : null
            };
        }

        case actionTypes.GET_ALL_DATUM_ORDER_REQ: {
            return {
                ...state,
                accept: action.payload?.data,
                statusCode: action.payload?.status,
                isLoading: false,
                sessionExpired: false,
            }
        }
        case actionTypes.GET_PLACE_ORDER: {
            return {
                ...state,
                placeOrder: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_PAYMENT: {
            return {
                ...state,
                orderSuccess: action.payload,
                orderPaymentInfo: action.payload?.data,
                orderNumber: action.payload?.data?.order_id,
                isPayLoading: false,
                openPayDialog: true,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_PLACE_ORDER_FAIL: {
            return {
                ...state,
                getOrderError: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_ALL_ORDERS_FAIL: {
            return {
                ...state,
                getOrderError: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_SINGLE_ORDER: {
            return {
                ...state,
                singleOrder: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_CURRENT_ORDER: {
            return {
                ...state,
                currentOrder: action.payload,
                count: 1,
                isLoading: false,
                sessionExpired: false,
                currentOrdersNext: null
            };
        }
        case actionTypes.GET_ONGOING_ORDER: {
            return {
                ...state,
                ongoingOrder: action?.payload?.results,
                count: action.payload.count,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_PAST_ORDER: {
            return {
                ...state,
                // ongoingOrder: action.payload===undefined? 0: action.payload ,
                pastOrder: getUnique(state.pastOrder.concat(action.payload.results), 'id'),
                count: action?.payload?.count,
                isLoading: false,
                sessionExpired: false,
                pastOrdersNext: action.payload?.next
            };
        }
        case actionTypes.GET_OVERDUE_ORDER: {
            return {
                ...state,
                // overdueOrder: action.payload===undefined? 0: action.payload,
                overdueOrder: action.payload,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_COUNT: {
            return {
                ...state,
                // isLoading:false,
            }
        }
        case actionTypes.EDIT_RECEIVER: {
            return {
                ...state,
                isLoading: false,
            }

        }
        case actionTypes.EDIT_RECEIVER_LOADING: {

            return {
                ...state,
                isLoading: true,
            }

        }
        case actionTypes.EDIT_RECEIVER_FAIL: {
            return {
                ...state,
                isLoading: false,
            }

        }
        case actionTypes.CANCEL_ORDER_LOADING: {
            return {
                ...state,
                isLoading: false,
            }

        }
        case actionTypes.CANCEL_ORDER: {
            return {
                ...state,
                isLoading: false,
                cancelOrder: action?.payload
            }

        }
        case actionTypes.CANCEL_ORDER_FAIL: {
            return {
                ...state,
                isLoading: false,
                cancelOrder: action?.payload
            }
        }
        case actionTypes.GET_ENERGY_SCORE: {
            return {
                ...state,
                isLoading: false,
                energyScore: action?.payload
            }
        }
        case actionTypes.GET_ENERGY_SCORE_FAIL: {
            return {
                ...state,
                isLoading: false,
                energyScore: action?.payload
            }
        }
        case actionTypes.CLEAR_ALL_DATA: {
            return {
                allOrders: [],
                allPartnerOrders: [],
                currentOrder: [],
                pastOrder: [],
            }
        }
        case actionTypes.CLEAR_ALL_UNFILTERED_ASSET_LIST: {
            return {
                ...state,
                unfilteredAssetList: [],
                isLoadingUnfilteredAssets: false,
                sessionExpired: false,
                next: null,
                previous: null,
                count: 0,
            }
        }
        case actionTypes.RESET_ORDER_STATE: {
            return {
                ...state,
                allAssetList: [],
                allAssetListCount: 0,
                isLoadingAllAssets: false,
                sessionExpired: false,
                allAssetListNext: null,
                lowAssetList: [],
                lowAssetListCount: 0,
                isLoadingLowFuel: false,
                lowAssetListNext: null,
            };
        }
        case actionTypes.CLOSE_PAY_DIALOG: {
            return {
                ...state,
                openPayDialog: false,
            };
        }
        case actionTypes.GET_LOCATION: {
            return {
                ...state,
                getLocation: action.payload.results,
                isLoading: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_LOCATION_FAIL: {
            return {
                ...state,
                getLocationError: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_REFILL_REPORT_FAIL: {
            return {
                ...state,
                isLoading: false,
                sessionExpired: false,
            }
        }
        case actionTypes.GET_REFILL_REPORT: {
            return {
                ...state,
                isLoading: false,
                sessionExpired: false,
            }
        }
        case actionTypes.REFILL_LOADING: {
            return {
                ...state,
                isLoading: true,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_AMOUNT: {
            return {
                ...state,
                getPaylableAmount: action.payload,
            }
        }
        case actionTypes.GET_FLEET_ACCOUNT: {
            return {
                ...state,
                getFleetAccount: action.payload.results,
            }
        }
        case actionTypes.GET_PLACE_ORDER_DATA: {
            return {
                ...state,
                getPlaceorderData: action.payload,
            }
        }
        case actionTypes.GET_ALL_ASSET_LIST: {
            // The API returns paginated {results, count, next} normally,
            // but a flat single object {id, name, …} when only one asset exists.
            const newResults = Array.isArray(action.payload?.results)
                ? action.payload.results
                : action.payload?.id != null
                    ? [action.payload]
                    : [];
            const count = action.payload?.count ?? newResults.length;
            const hasMore = newResults.length > 0 && !!action.payload?.next;
            const prevList = Array.isArray(state.allAssetList)
                ? state.allAssetList.filter(Boolean)
                : [];
            const allAssetList = action.fetchMoreData
                ? getUnique(prevList.concat(newResults), "id")
                : getUnique(newResults, "id");
            return {
                ...state,
                allAssetList,
                allAssetListCount: count,
                isLoadingAllAssets: false,
                sessionExpired: false,
                allAssetListNext: hasMore ? action.payload.next : null
            };
        }
        case actionTypes.GET_ALL_LOW_FUEL_ASSET_LIST: {
            const hasMore = action?.payload?.results?.length > 0 && action?.payload?.next;
            const currentList = Array.isArray(state.lowAssetList) ? state.lowAssetList : [];
            const newResults = Array.isArray(action.payload?.results) ? action.payload.results : [];
            const lowAssetList = action.fetchMoreData
                ? getUnique(currentList.concat(newResults), "id")
                : getUnique(newResults, "id");
            return {
                ...state,
                lowAssetList,
                lowAssetListCount: action.payload?.count || 0,
                isLoadingLowFuel: false,
                sessionExpired: false,
                lowAssetListNext: hasMore ? action.payload.next : null
            };
        }
        case actionTypes.ORDER_LOADING_ALL_ASSETS: {
            return {
                ...state,
                isLoadingAllAssets: true,
                sessionExpired: false,

            };
        }
        case actionTypes.ORDER_LOADING_LOW_FUEL: {
            return {
                ...state,
                isLoadingLowFuel: true,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_ALL_ASSET_LIST_FAIL: {
            return {
                ...state,
                assetListFail: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_LOW_ASSET_LIST_FAIL: {
            return {
                ...state,
                lowAssetFail: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_PARTNER_LIST: {
            const hasMore = action?.payload?.results?.length > 0 && action?.payload?.next;
            return {
                ...state,
                partnerList: getUnique(
                    state.partnerList?.concat(action.payload.results),
                    "id"
                ),
                partnerLogos: action.payload,
                count: action.payload.count,
                isLoading: false,
                sessionExpired: false,
                partnerListNext: hasMore ? action.payload.next : null
            };
        }
        case actionTypes.GET_FAIL: {
            return {
                ...state,
                failedReason: action.payload,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.PARTNER_LOADING_LOW_FUEL: {
            return {
                ...state,
                isLoadingPartnerList: true,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_ORDER_SUMMARY_LIST: {
            if (state.orderSummaryRequestId != null && action?.meta?.requestId != null && action.meta.requestId !== state.orderSummaryRequestId) {
                return state;
            }
            return {
                ...state,
                orderSummaryList: action.payload,
                isLoadingorderSummary: false,
                isLoading: false,
                sessionExpired: false,

            };
        }

        case actionTypes.RESET_ORDER_SUMMARY_LIST: {
            return {
                ...state,
                orderSummaryList: '',
                isLoadingorderSummary: false,
                isLoading: false,
                sessionExpired: false,

            };
        }

        case actionTypes.GET_ORDER_SUMMARY_FAIL: {
            if (state.orderSummaryRequestId != null && action?.meta?.requestId != null && action.meta.requestId !== state.orderSummaryRequestId) {
                return state;
            }
            return {
                ...state,
                orderSummaryFail: action.payload,
                isLoadingorderSummary: false,
                isLoading: false,
                sessionExpired: false,

            };
        }
        case actionTypes.LOADING_ORDER_SUMMARY: {
            return {
                ...state,
                isLoadingorderSummary: true,
                orderSummaryRequestId: action?.meta?.requestId ?? state.orderSummaryRequestId,
                sessionExpired: false,

            };
        }
        case actionTypes.GET_ALL_CITY:{
            return {
                ...state,
                cityList: action.payload,
                isLoadingCity: false,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_ALL_CITY_LIST_FAIL:{
            return {
                ...state,
                isLoadingCity: false,
                sessionExpired: false,
            };
        }
        case actionTypes.CITY_LOADING:{
            return {
                ...state,
                isLoadingCity: true,
                sessionExpired: false,
            };
        }
        case actionTypes.GET_UNFILTERED_ASSET_LIST:{
            return {
                ...state,
                unfilteredAssetList: getUnique(
                    state.unfilteredAssetList.concat(action.payload.results),
                    "id"
                ),
                count: action.payload.count,
                next: action.payload.next,
                previous: action.payload.previous,
                isLoadingUnfilteredAssets: false,
                sessionExpired: false,
            }
        }
        case actionTypes.GET_UNFILTERED_ASSET_LIST_FAIL:{
            return {
                ...state,
                isLoadingUnfilteredAssets: false,
                sessionExpired: false,
            }
        }
        case actionTypes.ORDER_LOADING_UNFILTERED_ASSETS:{
            return {
                ...state,
                isLoadingUnfilteredAssets: true,
                sessionExpired: false,
            }
        }
        default: {
            return state;
        }
    }
};

export default orderReducer;
